import { render, staticRenderFns } from "./commerce-filter.vue?vue&type=template&id=61e0118a"
import script from "./commerce-filter.vue?vue&type=script&lang=js"
export * from "./commerce-filter.vue?vue&type=script&lang=js"
import style0 from "./commerce-filter.vue?vue&type=style&index=0&id=61e0118a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports